/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class DrugsResponse extends IceEntity {
  gettablename(): string {
    return "DrugsResponse";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "DrugList") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "DrugList") return "Drug";
    else if (ColumnName == "RXNCONSOLIST") return "RXNCONSO";
    else if (ColumnName == "RXNSATLIST") return "RXNSAT";
    else if (ColumnName == "RXNALTLIST") return "RXNCONSO";

    return null;
  }
}

export class DrugsSideEffectsResponse extends IceEntity {
  gettablename(): string {
    return "SideEffectsResponse";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "SideEffectList") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "SideEffectList") return "SideEffect";

    return null;
  }
}

export class DrugIngredientsResponse extends IceEntity {
  gettablename(): string {
    return "IngredientsResponse";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "CompositionList") return true;
    else if (ColumnName == "IngredientList") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "CompositionList") return "DrugComposition";
    else if (ColumnName == "IngredientList") return "Ingredient";

    return null;
  }
}

/*
<DRUGCOMPOSITION><KEY>409C542EB33347D5BB4ADBCAA27357</KEY><CODE>NOCODE</CODE><TITLE>Composition(s)</TITLE><SUB_TYPE>0</SUB_TYPE><DITXML >
<IngredientsResponse xmlns:i="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://schemas.datacontract.org/2004/07/DITRestService"><CompositionList><DrugComposition><Form>5640|WK2XYI10QM</Form><Information i:nil="true" /><IngClass>W</IngClass><IngCode>213251</IngCode><IngName>IBUPROFEN</IngName><Quantity>100.00000</Quantity><RXCuIing>5640</RXCuIing><TtyIng>IN</TtyIng><Unit>MG</Unit></DrugComposition></CompositionList><IngredientList /><ResponseStatus xmlns:d2p1="http://schemas.servicestack.net/types"><d2p1:ErrorCode i:nil="true" /><d2p1:Message i:nil="true" /><d2p1:StackTrace i:nil="true" /><d2p1:Errors i:nil="true" /></ResponseStatus><Status xmlns:d2p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"><d2p1:string>Service Request On 18.10.2021 08:31:09 - Server: (local)\SQLEXPRESS; Database: DIT_SCHOLZ_DataBank</d2p1:string></Status><VersionInfo>{ DB upd: 202109 | API ver: 6.3.0.6 | DLL ver: 6.3.0.6 | Release Date: 23.06.2021 09:50:50}</VersionInfo></IngredientsResponse></DITXML></DRUGCOMPOSITION>
*/

export class DrugSideEffect extends IceEntity {
  dose: string = "";
  effect: string = "";
  frequency: string = "";
  frequencytext: string = "";
  ingcode: string = "";
  ingredient: string = "";
  relevance: string = "";
  relevancetext: string = "";
  route: string = "";
  thcode: string = "";
  time: string = "";
  gettablename(): string {
    return "SideEffect";
  }
}

export class DrugIngredient extends IceEntity {
  _id: string = "";
  information: string = "";
  ingcode: string = "";
  inggroupcode: string = "";
  ingredient: string = "";
  ingname: string = "";
  sxingname: string = "";
  gettablename(): string {
    return "Ingredient";
  }
}

export class DrugComposition extends IceEntity {
  form: string = "";
  information: string = "";
  ingclass: string = "";
  ingcode: string = "";
  ingname: string = "";
  quantity: number = 0.0;
  rxcuiing: string = "";
  ttying: string = "";
  unit: string = "";

  gettablename(): string {
    return "DrugComposition";
  }
}

export class Drug extends IceEntity {
  brandgen: string = "";
  brandname: string = "";
  dea: string = "";
  dosageform: string = "";
  drugcode: string = "";
  ndccode: string = "";
  drugname: string = "";
  genericname: string = "";
  marketstatus: string = "";
  ncitcode: string = "";
  packsize: string = "";
  packtype: string = "";
  rxcui: string = "";
  release: string = "";
  route: string = "";
  strength: string = "";
  syncode: string = "";
  syncode10: string = "";
  therapyclass: string = "";

  gettablename(): string {
    return "Drug";
  }
}

export class RXNCONSO extends IceEntity {
  rxcui: string = "";
  lat: string = "";
  ts: string = "";
  lui: string = "";
  stt: string = "";
  sui: string = "";
  ispref: string = "";
  rxaui: string = "";
  saui: string = "";
  scui: string = "";
  sdui: string = "";
  sab: string = "";
  tty: string = "";
  code: string = "";
  str: string = "";
  srl: string = "";
  suppress: string = "";
  cvf: string = "";

  gettablename(): string {
    return "RXNCONSO";
  }
}

export class RXNSAT extends IceEntity {
  rxcui: string = "";
  lui: string = "";
  sui: string = "";
  rxaui: string = "";
  stype: string = "";
  code: string = "";
  atui: string = "";
  satui: string = "";
  atn: string = "";
  sab: string = "";
  atv: string = "";
  suppress: string = "";
  cvf: string = "";

  gettablename(): string {
    return "RXNSAT";
  }
}
